// import NewsFeed from "../../components/NewsFeed/NewsFeed";

const Homepage = (props) => {
  return (
    <>
      <div>
        <h3>Welcome</h3>
        <br />
        <div>
          Updates:
          <ul>
            <li>2026 season updates are now live!</li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Homepage;